goog.provide("shadow.js.shim.module$$mui$material$TableBody$default");
shadow.js.shim.module$$mui$material$TableBody$default = shadow.js.require(533, {})["default"];
